
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartShipRoutingSystemIec as ObiChartShipRoutingSystemIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-ship-routing-system-iec.js';
 
 
 

 
 export const ObiChartShipRoutingSystemIec = createComponent({
   react: React,
   tagName: 'obi-chart-ship-routing-system-iec',
   elementClass: ObiChartShipRoutingSystemIecElement,
   events: {
     
   }
  });
 
 